import axios from "axios";
import { Constants } from '../utils/Constants';

export function update(form) {
  return axios.patch(`${Constants.baseUrl}/usuario/primeiroAcesso`, form);
}
